const pickerDateFormatter = new Intl.DateTimeFormat("en-US", { timeZone: "UTC" });

export const apiToPickerDate = (d: string): string => pickerDateFormatter.format(new Date(d));

export const pickerToApiDate = (d: string): string => new Date(d).toISOString().split("T")[0];
